import { combineReducers } from 'redux';
import quests from './quests';
import riddles from './riddles';
import team from './team';

export default combineReducers({ quests, riddles, team });
